module.exports = __webpack_public_path__ + "static/media/wizualizacja-147.07cfd9af.png";